import { HolidayForm } from './HolidayForm';
import { useFormState } from './useFormState';
import logger from '../../utils/logger';
import type { FormData } from '../../types';

interface HolidayFormPanelProps {
  onSubmit: (sessionId: string, input: Record<string, unknown>) => void;
  initialData?: FormData | null;
  sessionId?: string;
  onBack?: () => void;
}

export function HolidayFormPanel({ onSubmit, initialData, sessionId, onBack }: HolidayFormPanelProps) {
  const { form, updateField } = useFormState(initialData);

  const handleSubmit = () => {
    logger.info('Form submitted', form);
    // Reuse existing session ID for modify flow, generate new one otherwise
    const sid = sessionId || crypto.randomUUID();

    const payload = {
      sessionId: sid,
      userName: form.userName || 'Guest',
      destination: form.destination,
      departure: form.departure,
      startDate: form.startDate,
      endDate: form.endDate,
      adults: Number(form.adults) || 1,
      children: Number(form.children) || 0,
      budget: form.budget || 'mid',
      interests: form.interests,
      requirements: form.requirements,
    };

    onSubmit(sid, payload);
  };

  return <HolidayForm form={form} onFieldChange={updateField} onSubmit={handleSubmit} onBack={onBack} style={{ height: '100%', width: '100%' }} />;
}
